module.exports = __webpack_public_path__ + "static/media/eKeeper-app.1d082abd.jpg";